import { render, staticRenderFns } from "./OneNotificationBanner.vue?vue&type=template&id=35211602&scoped=true&"
import script from "./OneNotificationBanner.vue?vue&type=script&lang=ts&"
export * from "./OneNotificationBanner.vue?vue&type=script&lang=ts&"
import style0 from "./OneNotificationBanner.vue?vue&type=style&index=0&id=35211602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35211602",
  null
  
)

export default component.exports